import React from 'react';

import DashboardLayout from '../layouts/Dashboard/Dashboard';

import ContactUs from '../components/ContactUs/ContactUs';
import { profile, notifications } from '../components/Dashboard/testData';
import {setPageTitle} from '../utils/helpers';

const ContactUsPageContainer = () => {
  setPageTitle('Contact us | Investec Save');

  return (
    <DashboardLayout notifications={notifications}>
      <ContactUs profile={profile} />
    </DashboardLayout>
  );

};

export default ContactUsPageContainer;
